import { Link } from 'react-router-dom';
import { useTenantsParaEmitir } from '../tenants';
import { FormularioDeEmision } from './FormularioDeEmision';

/**
 * Pantalla de emisión (KAN-145). Ruta `/emision`, dentro de la sesión pero
 * **sin `RequiereRol`**: `ADMIN` y `OPERADOR` son los únicos dos roles que
 * existen y los dos pueden emitir — la lista blanca que sí restringe quién
 * emite es la de los sistemas conectados (KAN-144), no la de las personas.
 *
 * Pide acá, una sola vez, los tenants que **hoy pueden emitir**
 * (`soloEmisores=true`) y se los pasa al formulario: ofrecer en el selector un
 * tenant que va a fallar con `409 operacion_invalida` es hacerle perder el
 * tiempo a quien factura.
 *
 * `FormularioDeEmision` se remonta solo si esta pantalla se desmonta (salir y
 * volver a entrar a `/emision`); "cargar otro comprobante" **no** remonta
 * nada — el formulario resetea sus propios campos y pide una clave de
 * idempotencia nueva él mismo (ver `alEmitirOtro` ahí). Forzar un remontaje
 * acá sería una segunda forma de lograr lo mismo que ya hace el formulario.
 */
export function PantallaDeEmision() {
  const tenants = useTenantsParaEmitir();

  if (tenants.isPending) {
    return (
      <main>
        <p role="status">Cargando tenants…</p>
      </main>
    );
  }

  if (tenants.isError) {
    return (
      <main>
        <p role="alert" className="error">
          No se pudo cargar la lista de tenants. Sin eso no se puede elegir a nombre de quién
          emitir.
        </p>
      </main>
    );
  }

  return (
    <main>
      <p>
        <Link to="/">Inicio</Link>
      </p>
      <h1>Emitir comprobante</h1>
      {tenants.data.length === 0 ? (
        <p role="alert" className="error">
          No hay ningún tenant habilitado para emitir ahora mismo (activo y con delegación de ARCA
          activa). No se puede cargar un comprobante hasta que haya alguno.
        </p>
      ) : null}
      <FormularioDeEmision tenants={tenants.data} />
    </main>
  );
}
